import LocalStorage from '../classes/LocalStorage';

export default function init(): void
{
	let localStorage: LocalStorage;
	localStorage = new LocalStorage( 'localStorage start' );
}